import { useColumnsInstalacionesOT } from '@/erp/tecnico/ats/shared/hooks'
import { EstadosOrdenTrabajoEnumChoice, TABLE_CONSTANTS, useTableFilter, useTableServerSideFiltering } from '@/shared'
import { useFetchOrdenTrabajos } from '@/shared/actions/erp'
import { GeneralTable, TableTabsScene } from '@/shared/components/ui'
import { OrdenTrabajo } from '@/shared/interfaces'
import { useState } from 'react'
import PreRejectedInstalacionAsigTecModal from './PreRejectedInstalacionAsigTecModal'
import { ManageSearch } from '@mui/icons-material'

type Props = {
    stateOT?: EstadosOrdenTrabajoEnumChoice;
    customColumns?: any;
}

const TableInstalacionesTecnicos = ({
    stateOT = EstadosOrdenTrabajoEnumChoice.EN_ESPERA,
    customColumns
}: Props) => {
        const [openRejectModal, setOpenRejectModal] = useState(false);
        const [OTSelected, setOTSelected] = useState<OrdenTrabajo|null>(null);

        // const setAlert = useUiStore(s => s.setAlert)
    
        // server side filters - colums table
        const { filterObject, columnFilters, setColumnFilters } =
          useTableServerSideFiltering();
    
        ///* table
        const {
          globalFilter,
          pagination,
          searchTerm,
          onChangeFilter,
          setPagination,
          onChangeRangeDate,
          cleanFilter,
        } = useTableFilter();
        const { pageIndex, pageSize } = pagination;
    
    
        ///* handlers
        const onEdit = (ordentrabajo: OrdenTrabajo) => {
          
          setOpenRejectModal(true);
          setOTSelected(ordentrabajo);
        };
    
        ///* columns
        const {
          columnsPreRechazoTecnicoATS
        } = useColumnsInstalacionesOT();


        const {
              data: OrdensTrabajoPagingRes,
              isLoading,
              isRefetching,
            } = useFetchOrdenTrabajos({
              enabled: true,
              params: {
                page: pageIndex + 1,
                page_size: pageSize,
                identificacion: searchTerm,
                ...filterObject,
                filterByState: false,
                estado_orden_trabajo: stateOT,
              },
            });

    return (
    <TableTabsScene
      globalFilter={globalFilter}
      onChangeFilter={onChangeFilter}
      searchInputText="por identificación"
      onChangeRangeDate={onChangeRangeDate}
      cleanFilter={cleanFilter}
    >
      <GeneralTable<OrdenTrabajo>
        columns={
          customColumns ||
          columnsPreRechazoTecnicoATS
        }
        data={OrdensTrabajoPagingRes?.data?.data || []}
        isLoading={isLoading}
        isRefetching={isRefetching}
        // // filters - server side
        enableManualFiltering={true}
        columnFilters={columnFilters}
        onColumnFiltersChange={setColumnFilters}
        // // search
        enableGlobalFilter={false}
        // // pagination
        pagination={pagination}
        onPaging={setPagination}
        rowCount={OrdensTrabajoPagingRes?.data?.count}
        // // actions ========
        enableColumnActions={true}
        actionsColumnSize={TABLE_CONSTANTS.ACTIONCOLUMN_WIDTH}
        // crud
        canEdit={true}
        onEdit={onEdit}
        editIcon={<ManageSearch fontSize="large" />}
        toolTipTitleEditIcon={'Ver Detalles'}
        canDelete={false}
      />
      <PreRejectedInstalacionAsigTecModal
        open={openRejectModal}
        setOpen={setOpenRejectModal}
        ordenTrabajo={OTSelected!}
      />
    </TableTabsScene>
  )
}

export default TableInstalacionesTecnicos